<template>
<div id="base">
  <div class="width-wrapper">
    <h4 class="p-standard-h4">
      <slot>
        学区を再検索
      </slot>
    </h4>
    <h5 v-if="subtitle" class="c-subtitle">
      <img src="@/assets/school-red@2x.png" alt="">
      小学校・中学校の学区を見る
    </h5>
    <div class="c-radios-wrapper">
      <div @click="form.type = '小学校'" class="c-radio-wrapper">
        <input v-model="form.type" id="elementary" type="radio" value="小学校">
        <label for="elementary"></label>
        <p>小学校</p>
      </div>
      <div @click="form.type = '中学校'" class="c-radio-wrapper">
        <input v-model="form.type" id="middle" type="radio" value="中学校">
        <label for="middle"></label>
        <p>中学校</p>
      </div>
    </div>
    <div class="c-fields-wrapper" v-click-outside="clearResults">
      <form v-on:submit.prevent="search">

        <div class="c-select-wrapper">
          <div class="p-standard-select-squared">
            <select name="prefecture" v-model="form.prefecture" id="prefecture" @change="getCities($event.target.value)" :disabled="prefecturesLoading">
              <option v-if="citiesLoading" value="" disabled selected>Loading...</option>
              <option v-else value="" disabled selected @click="form.prefecture = ''">都道府県</option>
              <option v-for="(item, index) in preflist" :key="index" :value="item.pref_code">{{item.pref_name}}</option>
            </select>
            <button v-if="form.prefecture" class="c-clear-select-button" @click.stop="handlePrefectureClear">
              <img src="@/assets/images/batsu-limit.png"/>
            </button>
          </div>

          <div class="p-standard-select-squared">
            <select name="city" v-model="form.city" id="city" :disabled="citiesLoading || !cityList || !cityList[0]">
              <option v-if="citiesLoading" value="" disabled selected>Loading...</option>
              <option v-else value="" disabled selected>市区町村</option>
              <option v-for="(item, index) in cityList" :key="index" :value="item.city_code">{{item.city_name}}</option>
            </select>
          </div>

        </div>
        <div class="c-search-wrapper">
          <div class="p-search-field-wrapper" >
            <div class="c-typeahead-mask"></div>
            <span></span>
            <input v-model="form.search" type="text" :class="`c-search-input p-search-field ${displayTypeaheadResults ? 'typeahead-input-open' : 'typeahead-input-closed'}`" placeholder="ケイアイ小学校、ケイアイ中学校" />
            <div v-if="isSearching || loading" class="loading-wrapper">
              <Loading class="small-loading" />
            </div>
            <div v-if="displayTypeaheadResults" class="c-typeahead-results-wrapper">
              <div class="c-typeahead-results">
                <div v-if="results" class="modal-body non-empty">
                  <ul>
                    <li v-for="( result ) in results" :key="result.id" @click="select(result)" class="modal-result">
                      <p>
                      {{result.establishment_body}} - {{result.name}}
                      </p>
                      <img src="@/assets/icon-arrow.png"/>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <button :disabled="!canSearch" :class="`c-search-button submit-button square-button ${!canSearch ? 'disabled-search-button' : ''}`" @click="() => search(true)">
            <img src="@/assets/icon-search-history-2.png" alt="">
          </button>
        </div>

        <p v-if="err.isErr" class="p-errmsg">
          <span>
            <img
              src="@/assets/attention.png"
              alt="エラー"
              width="22"
              height="22"
            />
          </span>
          {{err.errMsg}}
        </p>

      </form>

      <p style="margin-top:10px;font-size:12px;color:#AAA;line-height:1.5em;">この学区情報は、国土地理院（平成28年）のデータをもとに作成しています。一部の学校は含まれておりません。現在の正確な学区については各自治体へお問い合わせください。</p>

    </div>
  </div>
   <transition name="modal-fade">
    <div class="modal-mask" v-if="noResultModal">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-content-wrapper">
            <div class="modal-header">
              <h3 class="red">該当する学校・エリアが見つかりませんでした。</h3>
            </div>
            <div class="modal-body">
            </div>
            <div class="modal-controls">
              <button @click="noResultModal = false" class="modal-button">戻る</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</div>
</template>

<script>
import MixinAPI from '@/plugins/mixin-api';
import Loading from '@/components/common/Loading';

export default {
  name: 'SchoolDistrictsListSearch',
  mixins: [MixinAPI],
  props: ['subtitle'],
  components: { Loading },
  computed: {
    canSearch() {
      return !!(this.form.search || this.form.prefecture || this.form.city);
    },
    displayTypeaheadResults() {
      return this.results[0];
    },
  },
  data() {
    return {
      form: {
        type: '小学校',
        search: '',
        prefecture: '',
        city: '',
      },
      err: {
        isErr: false,
        errMsg: '',
      },
      isActivated: false,
      preflist: [],
      loading: false,
      raceToken: null,
      citiesLoading: false,
      prefecturesLoading: false,

      showResults: false,
      debounceTimeout: null,
      isSearching: false,

      cityList: null,
      results: [],
      noResultModal: false,
    };
  },
  async mounted() {
    try {
      this.prefecturesLoading = true;
      this.preflist = await this.getPrefectureList();
    } catch (e) {
      // console.error(e);
    } finally {
      this.prefecturesLoading = false;
    }
  },
  watch: {
    // eslint-disable-next-line func-names
    'form.search': function () {
      this.handleSearchChange();
    },
    // eslint-disable-next-line func-names
    'form.prefecture': function () {
      this.handleSelectChange();
    },
    // eslint-disable-next-line func-names
    'form.city': function () {
      this.handleSelectChange();
    },
    // eslint-disable-next-line func-names
    'form.type': function () {
      this.handleSelectChange();
    },
    modal(newValue) {
      this.results = [];
      if (newValue) {
        document.body.classList.add('modal-open');
      } else {
        this.err.isErr = false;
        this.err.errMsg = '';
        document.body.classList.remove('modal-open');
      }
    },
  },
  beforeDestroy() {
    document.body.classList.remove('modal-open');
  },
  methods: {
    async getCities(code) {
      try {
        this.form.city = '';
        this.citiesLoading = true;
        this.cityList = null;
        this.cityList = await this.getCityList(0, code, 0);
        this.form.city = this.cityList[0].city_code;
      } catch (e) {
        // console.log(e);
      } finally {
        this.citiesLoading = false;
      }
    },
    clearResults() {
      this.results = [];
    },
    handlePrefectureClear() {
      this.form.prefecture = '';
      this.form.city = '';
    },
    handleSearchChange() {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      if (!this.form.search && !this.form.prefecture && !this.form.city) {
        this.isSearching = false;
        return;
      }

      this.results = [];
      this.isSearching = true;
      const debounceTime = (this.form.prefecture || this.form.city) ? 0 : 200;

      this.debounceTimeout = setTimeout(async () => {
        await this.search();
        this.isSearching = false;
      }, debounceTime);
    },
    handleSelectChange() {
      if (!this.isActivated) {
        return;
      }
      if (!this.form.search && !this.form.prefecture && !this.form.city) {
        this.isSearching = false;
        this.results = [];
        return;
      }
      this.search();
    },
    async queryJuniorHighSchools() {
      return this.getJuniorHighSchools(this.form.search, this.getPrefName(this.form.prefecture), this.getCityName(this.form.city));
    },
    async queryElementarySchools() {
      return this.getElementarySchools(this.form.search, this.getPrefName(this.form.prefecture), this.getCityName(this.form.city));
    },
    getPrefName(code) {
      if (!code) {
        return '';
      }
      const prefecture = this.preflist.find(p => p.pref_code === code);
      return prefecture.pref_name;
    },
    getCityName(code) {
      if (!code) {
        return '';
      }
      const city = this.cityList.find(p => p.city_code === code);
      return city.city_name;
    },
    async search(isButtonPress) {
      if (!this.canSearch) {
        return;
      }
      this.isActivated = true;
      const shouldDisplayModal = isButtonPress;

      // eslint-disable-next-line no-new-object
      const asyncToken = new Object();
      this.raceToken = asyncToken;
      try {
        this.results = [];
        this.err.isErr = false;
        this.err.errMsg = '';
        this.loading = true;

        let data;
        if (this.form.type === '小学校') {
          data = await this.queryElementarySchools();
        } else {
          data = await this.queryJuniorHighSchools();
        }
        if (this.raceToken === asyncToken) {
          this.results = data;
          if (this.results.length < 1 && shouldDisplayModal) {
            this.noResultModal = true;
          }
        }
      } catch (e) {
        if (this.raceToken === asyncToken) {
          this.err.isErr = true;
          this.err.errMsg = 'エラーが発生しました。しばらく待ってからやり直してください。';
        }
      } finally {
        if (this.raceToken === asyncToken) {
          this.loading = false;
          this.raceToken = null;
        }
      }
    },
    async select(result) {
      this.$router.push(`/school-districts/${result.pref_code}/${result.establishment_body}/?id=${result.id}&type=${this.form.type}`);
    },
  },
};

</script>

<style scoped lang="scss">
@import "@/assets/style/parts_responsive.scss";
$tablet-width: 640px;
$desktop-width: 999px;

#base {
  padding: 32px 16px;
}

.width-wrapper {
  max-width: 480px;
  margin: auto;
}

.p-standard-h4 {
  text-align: center;
  font-size: 18px;
  margin: 6px 0;
}

.c-subtitle {
  font-size: 16px;
  padding: 12px 0;
  margin-top: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    margin-right: 10px;
    height: 24px;
    width: 24px;
  }
}

.c-radios-wrapper {
  margin-top: 6px;
  padding: 12px 0;
  display: flex;
  justify-content: center;

  .c-radio-wrapper {
    cursor: pointer;
    position: relative;
    padding: 0px 32px;
  }
}

.c-fields-wrapper{
  margin: 12px auto;

  .c-search-input {
    width: 100%;
  }

  .c-search-wrapper {
    margin-top: 12px;;
    display: flex;

    .c-search-button {
      flex-shrink: 0;
      width: 52px;
      margin-top: 0px;

      img {
        height: 24px;;
        width: 24px;;
      }
    }
  }

  .c-select-wrapper {
    display: flex;
    align-items: center;

    .c-clear-select-button {
      position: absolute;
      height: 18px;
      width: 18px;
      right: 60px;
      top: 18px;
      opacity: 0.5;
    }
  }
}

.disabled-search-button {
  background-color: grey;
  opacity: 0.3;
  cursor: not-allowed;

  &:hover {
    opacity: 0.3 ;
  }
  img {
    cursor: not-allowed;
  }
}

input[type=radio] {
  display:none;
}

input[type=radio]:checked + label {
    background-image: url(@/assets/checked_radio_button@2x.png);
    background-repeat: no-repeat;
    background-size: 100%;
    height: 20px;
    width: 20px;
    position: absolute;
    bottom: -3px;
    left: 0px;
    cursor: pointer;
}

input[type=radio] + label {
    background-image: url(@/assets/unchecked_radio_button@2x.png);
    background-size: 100%;
    background-repeat: no-repeat;
    height: 20px;
    width: 20px;
    position: absolute;
    bottom: -3px;
    left: 0px;
    cursor: pointer;
}

.c-typeahead-results-wrapper {
  position: relative;

  .c-typeahead-mask {
    position: absolute;
    z-index: 9;
    top: 0;
    right: 0;
  }

  .c-typeahead-results {
    position: absolute;
    background-color: white;
    z-index: 10;
    padding-left: 16px;
    padding-bottom: 10px;
    width: 100%;

    border: 1px solid #cccccc;
    border-radius: 0 0 24px 24px;
    border-top: 0;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.33);
  }

}

.p-search-field-wrapper {
  flex: 1;
  padding-right: 10px;

  .typeahead-input-closed:hover,
  .typeahead-input-closed:focus {
    border-radius: 24px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.33);
  }

  .typeahead-input-open {
    border-bottom: 0;
    border-radius: 24px 24px 0 0;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.33);
  }

  .loading-wrapper {
    height: 12px;
    width: 12px;
    margin: 0;
    position: absolute;
    top: 47%;
    right: 36px;

    .small-loading {
      margin:0;
      font-size: 4px;
    }
  }
}

.modal-body::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.modal-body {
  width: 94%;
  color: #666666;
  line-height: 28px;
  min-height: 40px;
  font-size: 14px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* IE 10+ */

  &.non-empty {
    max-height: 300px;
    overflow: scroll;
    overflow-x: hidden;
  }

  li {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0 20px;
    text-align: left;
    margin-top: 8px;
    border: 1px solid #CCCCCC;
    border-radius: 26px;
    height: 44px;
    font-weight: bold;
    color: red;

    &:hover {
      background-color: rgba(232,53,50,.2);
    }

    p {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-size: 14px;
      flex-grow: 1;
    }

    img {
      height: 18px;
      width: 18px;
      margin-left: auto
    }
  }
}

@media (min-width: $tablet-width) {
  h4 {
    text-align: center;
    font-size: 16px;
  }

  .modal-body {
    width: 90%;
  }

  .c-subtitle {
    font-weight: normal;
  }

  .width-wrapper {
    max-width: 620px;
  }

  .c-typeahead-results-wrapper {
    .c-typeahead-results {
      padding-left: 44px;
    }
  }

}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: table;
  transition: opacity 0.3s ease;
  background-color: rgba(255, 255, 255, 0.95)
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  max-width: 490px;
  max-height: 800px;
  position: relative;
  width: 90%;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.13);
  border: 1px solid #EFEFEF;
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-content-wrapper {
  position: relative;
  padding: 40px 30px 20px 30px ;
}

.modal-header h3 {
  font-size: 16px;
  margin-top: 0;
  color: #666666;
  text-align: center;
  font-weight: bold;
  line-height: 24px;

  &.red {
    color: red;
  }
}

.modal-controls {
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-button {
  border: 1px solid #CCCCCC;
  border-radius: 26px;
  height: 52px;
  width: 200px;
  font-size: 16px;
  font-weight: bold;
}

.modal-fade-enter-active, .modal-fade-leave-active {
  transition: opacity 0.25s;
}
.modal-fade-enter, .modal-fade-leave-to {
  opacity: 0;
}
</style>
